<template>
  <div class="p-10">
    <h4 class="p-10 b-b-1" v-if="title" v-html="title" :style="titleMarginStyle"></h4>
    <div v-else :style="{marginTop: typeof gutter === 'number' ? (gutter + 'px') : gutter}"></div>
    <slot name="title"></slot>
    <slot name="after-title"></slot>
    <div class="p-t-10">
        <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "Group",
  data() {
    return {};
  },
  props: {
    title: String,
    titleMarginStyle: String, 
    // 左边距
    labelWidth: String,
    // 对齐方式
    labelAlign: String,
    // 右边距
    labelMarginRight: String,
    // 无title 上边距
    gutter: [String, Number]
  }
};
</script>

